module.exports = __webpack_public_path__ + "img/3.462833d5.jpg";